import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';
import { UsuarioUseCase } from 'src/app/domain/usecases/usuario/usuario.usecase';

@Component({
  selector: 'app-title-and-breadcrumb',
  templateUrl: './title-and-breadcrumb.component.html',
  styleUrls: ['./title-and-breadcrumb.component.css']
})
export class TitleAndBreadcrumbComponent implements OnInit {

  @Input('titulo') titulo: string = '';
  ultima_conexion: string = '';
  account: AccountInfo | undefined = undefined;
  routerInterno: Router;
  routerPath: string = "/home";

  constructor(
    private router: Router,
    private usuarioUseCase: UsuarioUseCase,
    private authService: MsalService) { 
      this.routerInterno = router;
    }

  ngOnInit(): void {
    this.account = this.authService.instance.getAllAccounts().length > 0 ? this.authService.instance.getAllAccounts()[0] : undefined;
    this.construirUltimaConexion();
  }

  construirUltimaConexion(): void {
    if (this.usuarioUseCase.comprobarUltimaConexionSessionStorage()) {
      this.ultima_conexion = this.usuarioUseCase.getUltimaConexionSessionStorage();
    } else {
      var res = this.usuarioUseCase.ultimaConexion({ username: this.account!.username!, name: this.account!.name! });
      res.subscribe({
        next: data => {
          this.usuarioUseCase.guardarUltimaConexionSessionStorage(data);
          this.construirUltimaConexion();
        }
      });
    }
  }

}
